var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isFiltered())?_c('b-card',[_c('project-stats',{attrs:{"project":_vm.project}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.project.children),function(child,index){return _c('project-list-item',{key:index + '_' + child.id,attrs:{"project":child,"level":_vm.level+1}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e27165f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/projects/ProjectListItem.vue
// module id = null
// module chunks = 